import React from 'react';
import { Bot, Clock, FileCheck, BarChart3, Zap, Shield } from 'lucide-react';

const Features: React.FC = () => {
  const features = [
    {
      icon: <Bot className="text-[#7AEA53]" size={32} />,
      title: "Gestão Centralizada",
      description: "Todas as suas notas fiscais em um só lugar, com busca inteligente e organização automática"
    },
    {
      icon: <Clock className="text-[#7AEA53]" size={32} />,
      title: "Download Automático",
      description: "Baixe XMLs de todas as notas fiscais automaticamente das Secretarias da Fazenda"
    },
    {
      icon: <FileCheck className="text-[#7AEA53]" size={32} />,
      title: "Validação em Tempo Real",
      description: "Confira status, chaves de acesso e dados das notas em tempo real"
    },
    {
      icon: <BarChart3 className="text-[#7AEA53]" size={32} />,
      title: "Relatórios Detalhados",
      description: "Acompanhe status de notas, erros e inconsistências com relatórios completos"
    },
    {
      icon: <Zap className="text-[#7AEA53]" size={32} />,
      title: "API Robusta",
      description: "Integre com seu ERP via API REST com documentação completa"
    },
    {
      icon: <Shield className="text-[#7AEA53]" size={32} />,
      title: "Segurança Total",
      description: "Seus dados protegidos com criptografia e backup automático"
    }
  ];

  return (
    <section id="features" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-[#103541] mb-4">
            Solução Completa para Notas Fiscais
          </h2>
          <p className="text-[#2E6173] text-lg max-w-2xl mx-auto">
            Automatize o download, organização e gestão de documentos fiscais com 
            a plataforma mais completa do mercado
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-white p-6 rounded-xl border border-gray-100 hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
            >
              <div className="mb-4">{feature.icon}</div>
              <h3 className="text-xl font-semibold text-[#103541] mb-2">
                {feature.title}
              </h3>
              <p className="text-[#2E6173]">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;